<template>
<div class="navbar">
    <div class="logo nav-section-1">
      <router-link class="logo-link" to="/">
      Gunjan Bhutani
      </router-link>
    </div>
    <div class="social-links nav-section-4">
      <ul class="horizontal-list">
        <li><a href="mailto:contact@gunjanb.co">contact@gunjanb.co</a></li>
        <li> <a href="/GunjanB-CV.pdf" target="_blank">CV</a></li>
<!--         <li><a href="https://github.com/gunjanbgits" target="_blank">Github</a></li>
        <li><a href="https://www.linkedin.com/in/gunjan-bhutani-05036b31/" target="_blank">LinkedIn</a></li>
        <li><a href="https://www.instagram.com/gunjanb_co/" target="_blank">Instagram</a></li> -->
      </ul>
    </div>    
    <div class="intro-block nav-section-2-3" :class="{hidden : !$route.meta.rootActive}">
      <div class="intro-block-text">
        Multi-disciplinary designer & creative technologist based in San Francisco, CA.
        </div>
        <div class="section-label"><span class="line-breaker"><span class="italics scroll-button" href="#" v-scroll-to="'#recent'">recently, MFA Design</span></span><span class="line-breaker"> @ <a href="http://design.cca.edu" target="_blank">California College of the Arts</a></span></div>
        <div class="section-label"><span class="line-breaker"><span class="scroll-button italics" href="#" v-scroll-to="'#previously'">previously, User Experience Designer</span></span><span class="line-breaker"> @ <a href="https://www.adobe.com/" target="_blank">Adobe Systems</a></span></div>
    </div>
</div>
</template>

<script>
export default {
  name: "Navbar"
};
</script>

<!-- :class="{navHidden : $route.meta.navHide}" 
:class="{navHidden : $route.meta.navHide}"
:class="{navHidden : $route.meta.navHidden}" -->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.navbar
  width 100%
  padding 1rem
  box-sizing border-box
  z-index 999
  color #000
  position relative
  display grid
  grid-template-columns repeat(12, 1fr)
  grid-gap 1rem
  grid-auto-rows minmax(0px, auto)
  .nav-section-1
    grid-column 1 / span 3
  .nav-section-2-3
    grid-column 4 / span 6
  .nav-section-3
    grid-column 7 / span 3
  .nav-section-4
    grid-column 10 / span 3
.social-links
  color inherit
  text-align right
  .horizontal-list
    padding-right 20px
    li
      margin 0
      position relative
      &:after
        position absolute
        right -20px
        bottom 0
        content "↗"
        font-weight 200
.logo
  margin-bottom 1rem
  .logo-link
    color #000
    display inline-block
    transition all .3s
    transition-timing-function ease-out
    &:hover
      text-decoration none
.intro-block
  .intro-block-text
    margin-bottom 1rem
  .section-label
    font-size .875rem
.scroll-button
  border-bottom 1px dashed #000
  cursor s-resize
.small
  .navbar
    display block
    .social-links
      text-align left
      margin-bottom 2rem
    .logo
      font-size 1.5rem
      margin-bottom 2rem
.medium
  .nav-section-2-3
    grid-column 1 / span 7

</style>